import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Bluetooth"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 22.5C11.8915 22.4992 11.7843 22.4763 11.685 22.4325C11.4192 22.3095 11.2493 22.0429 11.25 21.75V13.8075L6.3075 18.75L5.25 17.6925L10.9425 12L5.25 6.30751L6.3075 5.25001L11.25 10.1925V2.25001C11.2493 1.95709 11.4192 1.69054 11.685 1.56751C11.9515 1.44484 12.265 1.48879 12.4875 1.68001L17.7375 6.18001C17.9041 6.32252 18 6.53078 18 6.75001C18.0094 6.95969 17.9305 7.16371 17.7825 7.31251L13.0575 12L17.7825 16.7175C17.9229 16.8591 18.0012 17.0507 18 17.25C17.9915 17.4587 17.8964 17.6544 17.7375 17.79L12.4875 22.29C12.356 22.4171 12.1827 22.4918 12 22.5ZM12.75 13.8075V20.1225L16.1475 17.205L12.75 13.8075ZM12.75 3.87752V10.1925L16.1475 6.79502L12.75 3.87752Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Bluetooth.vue"]]);
